export const aboutInfo = {
  brandName: '制服诱惑',
  tagline: '探索制服美学的无限可能',
  intro: '制服诱惑是一个专注于职业制服时尚与文化的原创内容平台。我们相信，每一套制服都承载着独特的美学密码和文化内涵。从白衣天使的温柔到蓝天上空的优雅，从校园青春的活力到职场女性的自信——我们致力于为热爱制服时尚的朋友们提供最专业、最全面的内容指南。',
  mission: '我们的使命是重新定义人们对制服的认知。制服不仅仅是工作服，它是身份的象征、文化的载体、时尚的灵感源泉。通过深度的文化解析、实用的穿搭指南和精彩的视觉呈现，我们希望帮助每一位读者发现制服之美的独特魅力。',
  history: [
    { year: '2024', event: '制服诱惑平台正式成立，以公众号形式开始运营' },
    { year: '2025', event: '团队扩展至10人，内容覆盖8大制服品类' },
    { year: '2026', event: '网站正式上线，日均访问量突破10万' },
  ],
  testimonials: [
    {
      name: '小雨',
      role: 'cosplay爱好者',
      content: '制服诱惑的cosplay指南真的太详细了！从选材到制作，每一步都讲得很清楚。我的护士cosplay在漫展上拿到了最佳服装奖！',
      rating: 5,
    },
    {
      name: 'Emily',
      role: '空乘学员',
      content: '准备空乘面试时发现了这个网站，面试穿搭指南让我顺利通过了形象考核。现在已经是一名正式空姐了！',
      rating: 5,
    },
    {
      name: '职场新人小林',
      role: '互联网公司运营',
      content: 'OL穿搭攻略救了我的职场形象！从面试到转正，制服诱惑的穿搭建议一直是我的秘密武器。',
      rating: 5,
    },
    {
      name: '小宇',
      role: '摄影爱好者',
      content: '制服cosplay摄影指南帮我拍出了超有质感的定妆照，客户满意度直线上升！强烈推荐给每一位cosplay摄影爱好者。',
      rating: 4,
    },
  ],
  contact: {
    email: 'contact@dpxiong.cn',
    wechat: 'zhifuyouhuo_official',
    weibo: '@制服诱惑官方',
    address: '上海市静安区南京西路1788号',
    phone: '021-6288-8888',
  },
};